<template lang="html">
  <item-editor-dialog
    :id="selectedItemId"
    ref="editForm"
    v-model="selectedPanel"
    :show="showItem"
    :clone-id="cloneId"
    :title="pageTitle"
    :on-close="doClose"
    :context-menu="defaultContextMenu"
    :lock-timer="lockTimerSettings"
    :loading="isDataLoading"
    :errors="errors"
    :edit-panel-id="editPanel"
    :audit-panel-id="auditPanel"
    :audit="auditHistorySettings"
    :buttons="pageBarButtons"
  >
    <!-- START OF FORM FIELDS -->
    <v-flex class="pa-3">
      <v-text-field
        v-model.trim="itemData.name"
        :label="type + ' Name'"
        :rules="rules().required('Name')"
        :error-messages="getPathErrors(jsonPath, 'name')"
        :disabled="isFormDisabled"
        required
        @input="clearPathErrors(jsonPath, 'name')"
      />

      <v-textarea
        v-model.trim="itemData.notes"
        label="Comments"
        :rows="1"
        auto-grow
        :error-messages="getPathErrors(jsonPath, 'notes')"
        :disabled="isFormDisabled"
        @input="clearPathErrors(jsonPath, 'notes')"
      />

      <v-boolean
        v-model="itemData.disabled"
        label="Enabled"
        invert
        :error-messages="getPathErrors(jsonPath, 'disabled')"
        :field-errors="getPathErrors(jsonPath, 'disabled')"
        :disabled="isFormDisabled"
      />
    </v-flex>
    <!-- END OF FORM FIELDS -->
  </item-editor-dialog>
</template>

<script>
import {itemEdit} from '@/ft-vue-core'

var itemDefault = {
  name: '',
  notes: '',
  disabled: false,
  id: null,
  recordLockExpiration: null
}

export default {
  name: 'PosSalesAreaItem',
  components: {
  },
  mixins: [itemEdit],
  data: function () {
    return {
      type: 'Sales Area',
      types: 'Sales Areas',
      apiRecordCommand: 'posSalesArea',
      itemDefault: itemDefault
    }
  },
  computed: {
  }
}
</script>
